import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 311,
	height: 304,
	fill: "none",
	viewBox: "0 0 311 304",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_f_22225_221851)",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#f2f2f2",
				fillOpacity: .1,
				d: "M277.19 168.21c1.3 63.88-51.45 116.75-117.8 118.1S38.2 236.96 36.9 173.09C35.6 109.2 88.35 56.34 154.7 54.99s121.18 49.34 122.48 113.22"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter1_f_22225_221851)",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#f2f2f2",
				fillOpacity: .08,
				d: "M275.47 148.41c1.29 63.88-51.45 116.75-117.8 118.1S36.47 217.16 35.19 153.29c-1.3-63.88 51.44-116.76 117.8-118.1 66.35-1.35 121.18 49.34 122.48 113.22"
			})
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 80.55,
			cy: 78,
			fill: "#feffe2",
			rx: 80.55,
			ry: 78,
			transform: "rotate(-1.16 4131.48 -3575.3)"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_22225_221851",
			width: 163,
			height: 157,
			x: 74,
			y: 81,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "alpha" },
			children: /* @__PURE__ */ _jsx("ellipse", {
				cx: 80.55,
				cy: 78,
				fill: "#feffe2",
				rx: 80.55,
				ry: 78,
				transform: "rotate(-1.16 4131.48 -3575.3)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_22225_221851)",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#e7e8cc",
				d: "M234.89 134.03c-21.17 63.24-33.46 76.05-122.93 93.07 33.95 45.6 183.42 49.95 122.93-93.07"
			})
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 15.19,
			cy: 15.2,
			fill: "#e7e8cc",
			rx: 15.19,
			ry: 15.2,
			transform: "rotate(-1.16 5940.06 -5155.54)"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 7.92,
			cy: 7.93,
			fill: "#e7e8cc",
			rx: 7.92,
			ry: 7.93,
			transform: "rotate(-1.16 7402.35 -8750.06)"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 5.94,
			cy: 5.95,
			fill: "#e7e8cc",
			rx: 5.94,
			ry: 5.95,
			transform: "rotate(-1.16 9080.23 -6113.3)"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 4.62,
			cy: 4.63,
			fill: "#e7e8cc",
			rx: 4.62,
			ry: 4.63,
			transform: "rotate(-1.16 5143 -6644.5)"
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "santa",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fill: "#031839",
					d: "m40.76 127.3.24.13a.7.7 0 0 1-.26 1.3l-1.05.1c-.46.05-.92-.09-1.28-.38l-.4-.33a3 3 0 0 1-1.1-2.04l-.23-2.27a3.2 3.2 0 0 1 2.84-3.49l.37-.03q.69-.07 1.3.25l.75.4a1.21 1.21 0 0 0 1.78-1.2l-.2-1.94a6 6 0 0 1 .04-1.44l.35-2.47c.11-.74-.03-1.5-.4-2.15l-.11-.22a3 3 0 0 0-1.88-1.4l-1.07-.25a1.34 1.34 0 0 1-.86-2l.14-.22c.34-.57.93-.95 1.6-1.02l.83-.08c.97-.1 1.77-.8 1.98-1.76l.08-.33q.06-.26-.02-.51l-.62-2a.38.38 0 0 1 .6-.4c.24.19.6.03.62-.28l.06-1.66-.01-.17-.1-.55c-.14-.67.75-1.02 1.11-.45.2.31.63.38.91.15l.22-.18a1 1 0 0 0 .3-.48l.08-.4a.8.8 0 0 1 1.38-.36l.02.02q.14.14.32.2l.2.06c.52.15.6.85.12 1.1a.6.6 0 0 0-.32.6l.02.21a.92.92 0 0 0 1.41.7l.21-.14c.33-.2.52-.57.5-.96L51 93.6a.41.41 0 0 1 .8-.17l.62 1.62c.38 1 1.54 1.47 2.52 1.03l.04-.02q.18-.08.34-.21l.66-.54a.97.97 0 0 1 1.55.5c.1.37.42.65.82.7l1.77.21a.45.45 0 0 1 0 .89l-2.65.27c-.91.09-1.79.4-2.56.88l-.83.53-1.59 1.23a4 4 0 0 0-1.38 2.09l-.32 1.22a1 1 0 0 0 .12.79 1 1 0 0 1-.43 1.44l-.2.1c-.47.2-.76.7-.7 1.2l.59 5.82a6 6 0 0 0 1.3 3.14l1.06 1.28c.69.84 1.6 1.47 2.63 1.83l2.46.84q.75.26 1.54.31l2.86.19q.63.04 1.25.21l1.06.3a4.1 4.1 0 0 0 3.63-.66 1.17 1.17 0 0 1 1.86.82l.03.3c.05.5-.2.98-.62 1.26l-.75.47a2.8 2.8 0 0 0-1.28 2.23l-.03.75.02.6.08.77q.16 1.39.88 2.56l2.22 3.5c.55.88.86 1.88.9 2.92l.1 2.49c.04 1 .55 1.92 1.38 2.48l.54.37a1.39 1.39 0 0 1-.63 2.53h-.09c-.47.05-.93-.13-1.24-.48l-.94-1.07a4 4 0 0 1-.84-1.48l-.92-2.87a6 6 0 0 0-1.13-2.02l-1.79-2.1a4.7 4.7 0 0 0-2.7-1.56 4.7 4.7 0 0 1-3.08-2.11l-.23-.37a5.7 5.7 0 0 0-3.42-2.47l-13.63-3.45a2 2 0 0 0-.4-.06l-.6-.03c-.9-.03-1.61.73-1.52 1.62l.01.14c.04.4.28.75.63.93m57.36 15.45.23.14a.69.69 0 0 1-.36 1.27l-1.06.03q-.71 0-1.24-.5l-.38-.36a3 3 0 0 1-.93-2.1l-.05-2.3a3.2 3.2 0 0 1 3.12-3.24l.37-.01q.69-.01 1.26.35l.73.47a1.21 1.21 0 0 0 1.87-1.05l-.04-1.95q-.01-.74.14-1.44l.56-2.43c.17-.73.09-1.5-.22-2.17l-.1-.23a3 3 0 0 0-1.76-1.56l-1.05-.32a1.34 1.34 0 0 1-.7-2.07l.16-.2a2.1 2.1 0 0 1 1.68-.9h.83a2.3 2.3 0 0 0 2.12-1.6l.1-.32a1 1 0 0 0 .02-.52l-.45-2.04a.38.38 0 0 1 .63-.36c.22.22.6.09.63-.22l.2-1.65v-.17l-.06-.56c-.08-.68.84-.96 1.15-.36.17.33.6.43.9.22l.23-.16a1 1 0 0 0 .33-.45l.12-.38a.8.8 0 0 1 1.4-.26l.02.03q.12.15.3.22l.2.07c.5.2.52.9.02 1.11a.6.6 0 0 0-.36.57v.22a.92.92 0 0 0 1.36.8l.22-.12c.34-.18.56-.53.57-.92l.19-5.35a.41.41 0 0 1 .8-.1l.5 1.66a1.87 1.87 0 0 0 2.42 1.23l.05-.01q.2-.07.36-.19l.7-.48a.97.97 0 0 1 1.5.61c.07.39.37.7.76.77l1.75.36a.45.45 0 0 1-.08.88l-2.66.06q-1.38.03-2.62.67l-.86.46-1.69 1.1a4 4 0 0 0-1.54 1.97l-.42 1.2a1 1 0 0 0 .06.79 1 1 0 0 1-.55 1.4l-.21.08c-.48.17-.8.63-.8 1.14l.13 5.85a6 6 0 0 0 1.05 3.24l.95 1.36c.62.89 1.48 1.6 2.47 2.03l2.39 1.04q.73.32 1.5.43l2.84.41q.63.1 1.23.32l1.04.4c1.21.45 2.57.31 3.67-.38.76-.48 1.76.06 1.78.96v.3c.02.5-.26.97-.7 1.2l-.79.42a2.8 2.8 0 0 0-1.45 2.12l-.1.74q-.03.3-.02.6l.01.78q.03 1.4.68 2.62l1.92 3.67c.49.92.72 1.95.68 2.98l-.1 2.5c-.05 1 .39 1.95 1.17 2.58l.5.4a1.38 1.38 0 0 1-.83 2.47h-.08c-.47.02-.92-.2-1.2-.58l-.85-1.14a4 4 0 0 1-.72-1.54l-.7-2.94a6 6 0 0 0-.95-2.1l-1.62-2.23a4.7 4.7 0 0 0-2.56-1.78 4.7 4.7 0 0 1-2.9-2.35l-.2-.38a5.7 5.7 0 0 0-3.22-2.75l-13.3-4.53a2 2 0 0 0-.4-.1l-.6-.07c-.88-.1-1.66.6-1.64 1.49v.15c.01.4.22.76.55.98m56.65 17.13.2.17a.7.7 0 0 1-.53 1.21l-1.05-.13a1.7 1.7 0 0 1-1.16-.66l-.33-.4a3 3 0 0 1-.61-2.23l.28-2.27a3.2 3.2 0 0 1 3.54-2.77l.37.04q.68.09 1.2.53l.66.57a1.21 1.21 0 0 0 2-.78l.23-1.94q.08-.7.35-1.4l.9-2.32c.26-.7.3-1.47.08-2.19l-.07-.24a3 3 0 0 0-1.52-1.79l-.99-.47a1.34 1.34 0 0 1-.4-2.14l.19-.19a2.1 2.1 0 0 1 1.78-.63l.84.1c.96.12 1.9-.4 2.32-1.28l.14-.3q.11-.24.1-.5l-.16-2.1c-.03-.37.44-.55.67-.26.2.25.58.17.66-.13l.43-1.6.03-.17.02-.56c.02-.68.96-.83 1.19-.19.12.35.52.5.85.34l.25-.12q.26-.14.4-.4l.17-.36a.8.8 0 0 1 1.42-.06l.02.03q.1.16.26.26l.2.1a.6.6 0 0 1-.14 1.1.6.6 0 0 0-.44.51l-.03.22a.92.92 0 0 0 1.23.98l.23-.08c.36-.13.63-.44.7-.83l.94-5.27a.41.41 0 0 1 .82.01l.25 1.72a1.9 1.9 0 0 0 2.23 1.57l.04-.01q.2-.04.38-.13l.76-.38a.97.97 0 0 1 1.4.82c.02.4.27.74.64.87l1.7.6a.45.45 0 0 1-.21.86l-2.64-.32a6 6 0 0 0-2.7.3l-.92.32-1.82.86a4 4 0 0 0-1.8 1.73l-.59 1.12a1 1 0 0 0-.06.8 1 1 0 0 1-.74 1.3l-.22.05c-.5.1-.88.51-.94 1.02l-.71 5.8a6 6 0 0 0 .58 3.36l.74 1.48a6 6 0 0 0 2.16 2.36l2.21 1.37q.68.43 1.44.64l2.75.82q.6.18 1.17.48l.97.54c1.13.62 2.5.68 3.68.15.83-.37 1.74.31 1.63 1.21l-.03.3c-.06.5-.4.92-.88 1.09l-.83.3c-.86.3-1.51 1-1.75 1.88l-.2.73-.1.58-.1.78q-.17 1.38.3 2.7l1.38 3.9c.35.97.43 2.03.24 3.05l-.45 2.44c-.19.99.1 2 .8 2.73l.44.48q.35.37.38.89c.03.85-.7 1.54-1.56 1.43h-.08a1.5 1.5 0 0 1-1.1-.76l-.68-1.24a4 4 0 0 1-.5-1.64l-.27-3a6 6 0 0 0-.65-2.22l-1.28-2.44a4.7 4.7 0 0 0-2.28-2.13 4.7 4.7 0 0 1-2.54-2.73l-.15-.41a5.7 5.7 0 0 0-2.79-3.18l-12.52-6.38a2 2 0 0 0-.39-.15l-.58-.15a1.47 1.47 0 0 0-1.83 1.24l-.02.14c-.05.4.1.79.4 1.05"
				}),
				/* @__PURE__ */ _jsx("path", {
					stroke: "#031839",
					strokeWidth: 2.95,
					d: "M47.95 115.33c13.01 6.88 32.4 20.64 54.49 16.95 19.39 7.62 35.34 19.17 61.1 19.17 4.72 0 32.4 19.9 58.9 8.84"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#031839",
					stroke: "#031839",
					strokeWidth: 1.31,
					d: "M252.37 188.37c7.79-.28 10.82-1.96 13.97-2.74-.25 11.22-60.7-2.88-65.27-4-5.97-1.47-7.84-11.04-.2-10.52 6.18.42 3.83 7.47 2.67 5.98.5-1.48.1-3.13-1.76-3.75-4.82-1.62-4.3 5-.42 6.18 12.7 3.86 43.23 9.13 51.01 8.85Zm9.43-26.13a7.6 7.6 0 0 1 1.8 5.7c-.53 6.2-8.1 7.82-11.83 7.86-3.17 1.4-9.22 2.19-8.02-6 1.5-10.22 12.41-10 13.27-9.7.7.23 1.9.08 1.57-1.82l-.37-1.36 3.58 1.2-1.27.95c-.79.7-.5 1.26 1.27 3.17Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#031839",
					stroke: "#031839",
					strokeWidth: 1.31,
					d: "M268.87 175.2a14.4 14.4 0 0 0-.82-7.87c-.18-1.15.74-1.93 1.57-2.36.22-.1.22-.46-.02-.54-10.3-3.55-17.4 3.39-19.8 7.52a.3.3 0 0 1-.24.13c-7.7-.37-18.55.04-23.16-.53-4.48-.54-10.57-3.77-11.63-5.65a.3.3 0 0 0-.33-.15c-10.36 2.43-8.43 10.61-4.76 11.89 44.67 15.52 58.1 2.84 59.19-2.44Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#031839",
					stroke: "#031839",
					strokeWidth: 1.31,
					d: "m254.27 188.46.58-4.2h-1.65l-.5 4.36zm-37.87-4.63 2.36-3.53-1.48-.72-2.36 3.71z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#031839",
					stroke: "#031839",
					strokeWidth: 2.61,
					d: "M224.84 168.6c-1.65-.32-.76 2.4-.1 3.82l.03.03c.7.73 3.58 2.74 9.61 5.1 7.6 2.97 13.12-10.54 14.22-12.96.86-1.9-1.89-7.34-3.48-10.02a.13.13 0 0 1 .12-.2l1.69.04q.13-.01.13-.15c-.3-1.67-.68-4.52.12-3.69 1.01 1.07 4.55 1.54 5.45 2.8 1.3 1.82 3.88 1.2 3.6-1.25-.3-2.45-2.81-.7-3.5-.72-.56-.02-1.59-1.9-2.03-2.85-3.68-6.37-5.45-5.02-7.89-5.07s-3.9 3.06-4.96 3.73c-.8.52-.44 2.16-.11 3.03q.03.11-.08.16l-1.55.59a.13.13 0 0 0-.09.12l-.03 1.6q0 .06-.03.1c-.85.92-2.47 2.92-2.5 3.74l-.05 2.6c0 .13-.25.2-.38.14-.32-.17-.81-.03-1.39 1.07-.87 1.65-5.44.58-7.64-.17h-.03c-7.96-.73-1.92 3.78.56 3.75q.08 0 .12.05l3.22 4.53c.05.07.01.17-.07.19a8 8 0 0 1-2.96-.11Z"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_f_22225_221851",
			width: 275.49,
			height: 266.53,
			x: 19.3,
			y: 37.38,
			colorInterpolationFilters: "sRGB",
			filterUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					result: "effect1_foregroundBlur_22225_221851",
					stdDeviation: 8.79
				})
			]
		}), /* @__PURE__ */ _jsxs("filter", {
			id: "filter1_f_22225_221851",
			width: 310.65,
			height: 301.7,
			x: 0,
			y: 0,
			colorInterpolationFilters: "sRGB",
			filterUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					result: "effect1_foregroundBlur_22225_221851",
					stdDeviation: 17.58
				})
			]
		})] })
	]
});
export default SvgMoon;
